module.exports = __webpack_public_path__ + "img/wrists.b8ef39aa.png";